import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faSearch } from "@fortawesome/free-solid-svg-icons";
import { statesAndCities } from "../../../../constants/statesAndCitiesConstants";
import "./MobileStateCityModal.scss";

interface MobileStateCityModalProps {
  show: boolean;
  onHide: () => void;
  onStateSelect: (state: string) => void;
  onCitySelect: (city: string) => void;
  selectedState: string;
  selectedCity: string;
  availableStates: string[];
  availableCities: string[];
  title: string;
  type: "state" | "city";
}

const MobileStateCityModal: React.FC<MobileStateCityModalProps> = ({
  show,
  onHide,
  onStateSelect,
  onCitySelect,
  selectedState,
  selectedCity,
  availableStates,
  availableCities,
  title,
  type,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);

  // Determinar qué opciones mostrar basado en el tipo
  const options = type === "state" ? availableStates : availableCities;

  // Filtrar opciones basado en el término de búsqueda
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [searchTerm, options]);

  const handleOptionClick = (option: string) => {
    if (type === "state") {
      onStateSelect(option);
    } else {
      onCitySelect(option);
    }
    onHide();
    setSearchTerm("");
  };

  const handleClose = () => {
    setSearchTerm("");
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className="mobile-state-city-modal"
      centered
      fullscreen="sm-down"
    >
      <Modal.Header className="modal-header-custom">
        <Modal.Title className="modal-title-custom">
          {title}
        </Modal.Title>
        <Button
          variant="link"
          onClick={handleClose}
          className="close-button-custom"
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Modal.Header>

      <Modal.Body className="modal-body-custom">
        {/* Barra de búsqueda */}
        <div className="search-container">
          <div className="search-input-wrapper">
            <FontAwesomeIcon icon={faSearch} className="search-icon" />
            <Form.Control
              type="text"
              placeholder={`Buscar ${type === "state" ? "estado" : "ciudad"}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </div>

        {/* Lista de opciones */}
        <div className="options-container">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                className={`option-item ${
                  (type === "state" && selectedState === option) ||
                  (type === "city" && selectedCity === option)
                    ? "selected"
                    : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                <span className="option-text">{option}</span>
                {(type === "state" && selectedState === option) ||
                (type === "city" && selectedCity === option) ? (
                  <div className="selected-indicator">✓</div>
                ) : null}
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>No se encontraron resultados para "{searchTerm}"</p>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MobileStateCityModal; 